<template>
    <div
        id="app"
        class="w-100 h-100"
        :class="user.permission"
    >
        <router-view @logged-in="checkAuth">
            <template #navbar-content />
        </router-view>
    </div>
</template>
<script lang="ts" setup>
import useStore from "@lib/stores";
import { computed, onBeforeMount, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const store = useStore();
const route = useRoute();
const router = useRouter();

const user = computed(() => store.user);
watch(user, (cur, prev) => {
    if(cur.loggedIn !== prev.loggedIn)
        checkAuth();
});

watch(() => route.name, () => {
    if(!user.value.loggedIn) {
        checkAuth();
    }
});

onBeforeMount(checkAuth);

function checkAuth() {
    store.auth()
        .then(() => {
            if(!user.value.loggedIn) {
                // stay on login page
            } else if(route.name == "login") {
                //router.push({name: "live_index"});
                return;
            }
        })
}


</script>

<style lang="scss">
@import '@fortawesome/fontawesome-free/css/all.css';
@import "@lib/scss/bootstrap-customize";
@import "@lib/scss/import";

// because it doesn't work well for wide screens...
@media screen and (min-width: $screen-width-xxl) {
    html {
        font-size: 14px!important;
    }
}

@media screen and (min-width: $screen-width-xxxl) {
    html {
        font-size: 14!important;
    }
}


@media screen and (min-width: $screen-width-xxl) and (min-height: $screen-height-xxl) {
    html {
        font-size: 14px!important;
    }
}

@media screen and (min-width: $screen-width-xxxl) and (min-height: $screen-height-xxxl) {
    html {
        font-size: 14!important;
    }
}

html, body {
    font-size: 14px!important;
}


#app #feedback-button-container {
    #feedback-button {
        transform-origin: 0 0;
        transform: rotate(-90deg);
    }
}

.item-table-container table {
    color: $color-text;
}
.table {
    --bs-table-color-state: $color-text!important;
}

@media screen and (max-width: $screen-width-xs) {

    #app .navbar {
        display: none!important;
    }
    #app .live-index .body {
        height: 100vh!important;
        max-height: unset;
    }

}

@media screen and (max-width: 600px) {
    body, #app, #login {
        width: 100%;
        height: 100%;
    }
}

$user-types: "admin_operator", "admin_user", "operator";

@each $user in $user-types {
    #app.#{$user} #user-profile {
        background-image: url("src/assets/img/#{$user}.png");
    }
}

#app-navbar-brand {
    margin-right: calc(var(--logo-size) * 1.25 + 80px);
    position: relative;
    &:after {
        content: "";
        position: absolute;
        background: url("src/assets/logos/logo.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: var(--logo-size);
        width: calc(var(--logo-size) * 1.25 + 60px);
        top: 0;
        left: calc(100% + 10px);
    }
}

#login #logo {
    margin-right: 160px;
    position: relative;
    &:after {
        content: "";
        position: absolute;
        background: url("src/assets/logos/logo_login.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        height: 85px;
        width: 175px;
        top: -10px;
        left: calc(100% + 15px);
    }
}

.table {
    --bs-table-hover-bg: #ffffff11;
    --bs-table-hover-color: $color-text!important;
}

</style>
